import Vue from "vue";
import Vuex from "vuex";
import Router from "./router";

Vue.use(Vuex);

const state = {
  isClient: false,
  cityCode: "picos_pi",
  cityInfo: {
    nomeCidade: "Picos - PI",
    telegram: {
      num: "0800 089 0089",
      id: "virtex_suporte"
    },
    whatsapp: "0800 089 0089",
    fixo: "0800 089 0089",
    pabx: ["(89) 3422 3902", "(89) 99988 1400", "(89) 99405 9174"],
    centralAssinanteUrl: "https://portal.virtex.com.br/person_users/login",
    endereco: {
      local: "Rua Francisco Prota",
      bairro: "Centro",
      numero: "138",
      cidade: "Picos",
      uf: "PI",
      cep: "64600-026",
      coordenada: {
        lat: "-7.084968",
        lon: "-41.469296"
      }
    }
  },
  menu: [
    { title: "Home", path: "home" },
    {
      title: "Planos",
      path: "planos"
    }
    // {
    //   title: "Banco de Talentos",
    //   path: "banco_de_talentos"
    // }
    // { title: "Contato", path: "contato" },
    // { title: "Notícias", path: "noticias" },
    // { title: "COVID 19", path: "covid" }
  ]
};

export default new Vuex.Store({
  state,
  mutations: {
    setUserClient(state, payload) {
      state.isClient = payload;
    },
    setCityInfo(state, payload) {
      state.cityCode = payload.cityCode;
      state.cityInfo = payload.cityInfo;
    }
  },
  actions: {
    redirectTo({ state }, payload) {
      Router.push(`${payload}`);
    },
    redirectToClientCenter({ state }) {
      window.open(state.cityInfo.centralAssinanteUrl, "_blank");
    },
    redirectToProtocolo() {
      window.open("https://protocolo.virtex.com.br", "_blank");
    },
    redirectToBancoTalentos() {
      window.open("https://virtextelecom.solides.jobs", "_blank");
    },
    redirectToVtxPay() {
      window.open("https://pay.virtex.com.br", "_blank");
    },
    redirectToAppAppleStore() {
      window.open("https://apps.apple.com/br/app/virtex-app/id1527307166", "_blank");
    },
    redirectToAppPlayStore() {
      window.open("https://play.google.com/store/apps/details?id=com.virtex.mobile", "_blank");
    }
  }
});
